import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

export interface HeaderAddFundsProps {
  onClick: () => void;
}

/** The header's "+ Add money" action (starts the guided flow): icon and word on every layout. */
export default function HeaderAddFunds({ onClick }: HeaderAddFundsProps) {
  const { t } = useTranslation();
  return (
    <Button
      variant="primary"
      size="md"
      icon={<Plus strokeWidth={2.5} />}
      data-tour-id="header.add_money"
      className="shrink-0"
      onClick={onClick}
    >
      {t('header.addMoney')}
    </Button>
  );
}
